import {useEffect} from 'react';
import {useAppDispatch} from '../../../hooks/redux';
import socketService from '../../../middleware/websocketMiddleware';
import {IAlert, IUnreadCount} from '../../../models/IAlert';
import {addAlert, setAlertConnected, setAlertList, setUnreadCount} from "../model/slice";

export function useAlertTracking() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const socket = socketService.connect();

        const handleConnect = () => {
            socket.emit('alert:join');
            dispatch(setAlertConnected(true));
        };

        const handleInitial = (data: { alerts: IAlert[]; unread: IUnreadCount }) => {
            dispatch(setAlertList(data.alerts));
            dispatch(setUnreadCount(data.unread));
        };

        const handleNew = (alert: IAlert) => {
            dispatch(addAlert(alert));
            // Пересчитываем unread локально — бек пришлёт актуальный счётчик
        };

        const handleUnreadCount = (data: IUnreadCount) => {
            dispatch(setUnreadCount(data));
        };

        const handleDisconnect = () => {
            dispatch(setAlertConnected(false));
        };

        if (socket.connected) handleConnect();

        socket.on('connect', handleConnect);
        socket.on('alert:initial', handleInitial);
        socket.on('alert:new', handleNew);
        socket.on('alert:unread_count', handleUnreadCount);
        socket.on('disconnect', handleDisconnect);

        return () => {
            socket.emit('alert:leave');
            socket.off('connect', handleConnect);
            socket.off('alert:initial', handleInitial);
            socket.off('alert:new', handleNew);
            socket.off('alert:unread_count', handleUnreadCount);
            socket.off('disconnect', handleDisconnect);
            dispatch(setAlertConnected(false));
        };
    }, [dispatch]);
}
